import { Modal } from 'antd';
import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.1); }
`;

export const StyledModalContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 50px 40px;
`;

export const StyledIconWrapper = styled.div`
    font-size: 72px;
    color: #1890ff;
    margin-bottom: 24px;
    animation: ${pulse} 2s ease-in-out infinite;
`;

export const StyledTitle = styled.h2`
    font-size: 22px;
    font-weight: 600;
    color: #262626;
    margin: 0 0 8px 0;
`;

export const StyledDescription = styled.p`
    font-size: 14px;
    color: #8c8c8c;
    margin: 0 0 32px 0;
`;

export const StyledProgressWrapper = styled.div`
    width: 100%;
    max-width: 400px;
`;

export const StyledModal = styled(Modal)`
    padding: 24px;
    position: absolute;
    top: 164px;
    left: 50%;
    transform: translateX(-50%);

    .ant-modal-close-x {
        margin-top: 7px;
        margin-right: 10px;
        font-size: 24px;
    }

    .ant-modal-close:hover {
        background-color: transparent !important;
    }

    &.ant-zoom-appear,
    &.ant-zoom-enter {
        transform: translateX(-50%) scale(1) !important;
    }

    .ant-modal-content {
        animation: none !important;
    }
`;

export const StyledCloseButton = styled.span.attrs({
    'data-e2e': 'download_close-support-modal_icon'
})``;
